<template>
    <div class="info-tooltip" style="margin-left: 5px;">
        <div id="info-tooltip-trigger" @click="open = !open">
            <i class="fas fa-info-circle"></i>
        </div>
        <div v-if="open" style="position:relative;" :style="{marginTop: marginTop}">
            <div class="info-tooltiptext bd text-block" :style="{marginLeft:marginLeft}">
                <a @click="close()"><i id="tooltip-close" class="fa fa-window-close"></i></a>
            <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoTooltip",
    props:["marginLeft", "marginTop"],
    data() {
        return {
            open: false
        }
    },
    methods: {
        close() {
            this.open = false;
        }
    }
}
</script>

<style scoped>

</style>
